<template>
  <div>
    <main class="home">
      <profile-section></profile-section>
      <action-todo-no-swipe
        v-if="$store.getters.getUserTasks"
        moreactions="/actions"
        :limit-actions="true"
        :tasks.sync="$store.getters.getUserTasks"
        :messages.sync="$store.state.messages"
        id="actions"
        v-cloak
      ></action-todo-no-swipe>

      <section id="rewards" v-if="nextReward !== undefined && nextReward !== null && typeof nextReward === 'object'" v-cloak>
        <div class="container">
          <div class="row justify-content-md-center">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="container-fluid">
                    <div class="row justify-content-md-center">
                      <div class="col-12 col-md-10">
                        <h2 class="text-center">{{$t('Next reward')}}</h2>
                      </div>
                    </div>
                    <div class="row justify-content-md-center">
                      <div class="col-12 col-md-10">
                        <router-link class="card" :to="'/catalog/rewards/?rewardId=' + nextReward.id">
                          <div class="card-body">
                            <div class="container-fluid">
                              <div class="row align-items-center">
                                <div class="col-12 col-md-5 text-center text-md-right pr-md-4">
                                  <img
                                    :src="nextReward.image"
                                    class="rounded img-fluid"
                                    style="max-height:240px"
                                  />
                                </div>
                                <div
                                  class="col-12 col-md-5 text-center text-md-left mt-md-0 mt-4 d-flex flex-column"
                                >
                                  <template v-if="nextReward.at_level">
                                    <h5
                                      class="card-title text-primary text-uppercase text-md-left text-center"
                                      v-cloak
                                    >{{$t('Level')}} {{nextReward.at_level}}</h5>
                                  </template>
                                  <template v-else>
                                    <h5
                                      class="card-title text-primary text-uppercase text-md-left text-center"
                                      v-cloak
                                    >{{nextReward.cost}} {{$t('points')}}</h5>
                                  </template>
                                  <h3 style="font-size:24px;margin-bottom:0px;">{{nextReward.title}}</h3>
                                  <p
                                    style="font-size:18px"
                                  >{{ (nextReward.description.length > 200) ? nextReward.description.substring(0,200) + '...' : nextReward.description }}</p>
                                  <h5
                                    class="text-primary text-center text-md-left"
                                    style="font-size:18px;margin-top:20px;"
                                  >
                                    <template v-if="!nextReward.redeemable">
                                      <div
                                        class="btn btn-grey text-uppercase"
                                        style="display: inline-block;cursor:initial;background-color: #21252908;"
                                      >
                                        <template
                                          v-if="nextReward.type === 'coins'"
                                        >{{$t('Già richiesto')}}</template>
                                        <template v-else>{{$t('Già sbloccato')}}</template>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <template v-if="nextReward.type == 'coins'">
                                        <template
                                          v-if="(nextReward.cost - $store.getters.getUserCoins) <= 0"
                                        >
                                          <div
                                            class="btn btn-primary text-uppercase"
                                            style="display: inline-block;"
                                          >{{$t('Mostra dettagli')}}</div>
                                        </template>
                                        <template v-else>
                                          <strong>{{$t('You have already')}} {{nextReward.cost - $store.getters.getUserCoins }} {{$t('coins per ottenerlo')}}</strong>
                                        </template>
                                      </template>
                                      <template v-else>
                                        <template
                                          v-if="(nextReward.cost - $store.getters.getUserPoints) <= 0"
                                        >
                                          <div
                                            class="btn btn-primary text-uppercase"
                                            style="display: inline-block;"
                                          >{{$t('Mostra dettagli')}}</div>
                                        </template>
                                        <template v-else>
                                          <strong>{{$t('You have already')}} {{nextReward.cost - $store.getters.getUserPoints }} {{$t('pt per sbloccarlo')}}</strong>
                                        </template>
                                      </template>
                                    </template>
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <router-link to="/catalog" class="a-more">{{$t('More Rewards')}}</router-link>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import ActionTodoNoSwipe from "./Campaign/ActionTodoNoSwipe";
import ProfileSection from "./Campaign/ProfileSection";
import _ from "lodash";

export default {
  name: "dashboard",
  components: {
    ActionTodoNoSwipe,
    ProfileSection
  },
  data() {
    return {
      nextReward: null
    };
  },
  created() {
    if (this.$store.getters.getUserTasks.length == 0) {
      this.$store.commit("showSpinner");
      this.$store.dispatch("getUserTasks").then(response => {
        this.$store.commit("hideSpinner");
      });
    }
  },
  mounted() {
    this.$http
      .get(
        "/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/catalog/rewards/nearest"
      )
      .then(response => {
        this.nextReward = _.get(response, "data.data", null);
      });
  }
};
</script>
<style>
#actions {
  margin-top: 50px;
}

@media (min-width: 768px) {
  .user-basic .col-12:first-of-type {
    border-right: 1px solid var(--primary);
  }
}

.user-basic .card-sector {
  width: 50%;
  padding: 0 1rem;
}
.user-basic .card-sector .card-title {
  line-height: 30px;
  margin-bottom: 0;
}
.user-basic .card-sector .card-title div {
  display: block;
  float: left;
}
.user-basic .card-sector .card-title svg {
  height: 30px;
  fill: currentColor;
}
.user-basic .card-sector .metric {
  padding-left: calc(0.5rem + 30px);
}
@media (max-width: 768px) {
  .user-basic .card-sector .card-title {
    font-size: 16px;
  }
}

.user-basic .card-sector .metric {
  padding-left: 0;
}

.user-basic .card-sector .metric .c-points__icon {
  display: inline-block;
}

.user-basic .card-sector .metric .c-points__icon svg {
  height: 30px;
  fill: currentColor;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 500;
}
</style>